import { Button, ErrorContainer } from 'components';
import { useFormikContext } from 'formik';
import { openAiScribeDrawer } from 'store/clients/clientsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { notifyUserError } from 'utils/notifications';

import { useNoteFormContext } from '../context/noteFormContext';
import { NoteFormValues } from '../utils';

export const AiScribeButton = () => {
  const aiScribe = useAppSelector((state) => state.clients.aiScribe);
  const dispatch = useAppDispatch();
  const { clientName, prependedClientId, clientId, onOpenAiScribeDrawer } = useNoteFormContext();
  const formik = useFormikContext<NoteFormValues>();

  const onRecord = () => {
    if (aiScribe.status === 'recording') {
      notifyUserError('There is already a recording in progress');
      return;
    }
    dispatch(
      openAiScribeDrawer({
        clientId: Number(clientId),
        clientName: clientName,
        prependedClientId: prependedClientId,
        note: formik.values
      })
    );
    onOpenAiScribeDrawer?.();
  };

  return (
    <>
      <Button
        type="button"
        text="Record"
        theme="primary"
        icon={<span className="material-icons">mic</span>}
        handleOnClick={onRecord}
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched?.note && formik.errors?.note}
        name="test"
      />
    </>
  );
};
